<template>
  <b-card class="rounded-xl border-none" no-body>
    <div>
      <div v-if="!isShowCreate">
        <b-input-group class="mt-12">
          <b-form-input
            class="border-none shadow-lg"
            type="text"
            min="0.00"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>

        <el-table
          class="table-responsive table-flush mt-6"
          header-row-class-name="thead-light table-th-color"
          :data="CategoryData"
        >
          <el-table-column label="ID" min-width="120px" prop="vid" sortable>
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.vid }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Group Name"
            min-width="140px"
            prop="name"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Total Contact"
            min-width="200px"
            prop="totalContact"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.totalContact }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Date"
            min-width="140px"
            prop="createDate"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.createDate }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Action"
            min-width="140px"
            prop="action"
            sortable
          >
            <template>
              <div class="flex items-center">
                <div class="flex items-center mr-4 cursor-pointer">
                  <feather-icon
                    @click="handleClick"
                    block
                    icon="EyeIcon"
                    svgClasses="w-5"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Edit"
                  ></feather-icon>
                </div>
                <div class="flex items-center cursor-pointer">
                  <feather-icon
                    icon="Trash2Icon"
                    svgClasses="w-5"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Delete"
                  ></feather-icon>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <b-card-footer class="py-4 d-flex justify-content-end">
          <base-pagination
            v-model="currentPage"
            :per-page="10"
            :total="50"
          ></base-pagination>
        </b-card-footer>
      </div>

      <div v-show="isShowCreate">
        <CreateVoiceBlastTemplate />
      </div>
    </div>
  </b-card>
</template>
<script>
import CreateVoiceBlastTemplate from "./CreateVoiceBlastTemplate";
import CategoryData from "./CategoryData";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    CreateVoiceBlastTemplate,
  },
  data() {
    return {
      CategoryData,
      currentPage: 1,

      isShowCreate: false,
    };
  },
  methods: {
    handleClick() {
      this.$router.push({ name: "addnumber-form" });
    },
  },
};
</script>
